import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, setConsent, subscribeConsent } from '../analytics/consent';
import { updateConsent } from '../analytics/ga';
import { Button } from './ui/button';
import './ConsentBanner.css';

/**
 * Small, non-blocking cookie consent card for the public pages. Accept and
 * Decline are equally prominent (opt-in requirement); no choice is stored
 * until the visitor clicks one, and analytics cookies are only set after
 * Accept (Consent Mode default is denied).
 */
const ConsentBanner = () => {
  const [choice, setChoice] = useState(() => getConsent());
  useEffect(() => subscribeConsent(setChoice), []);

  if (choice !== null) return null;

  const decide = (granted) => {
    setConsent(granted);
    updateConsent(granted);
  };

  return (
    <aside className="consent-banner" role="dialog" aria-label="Cookie consent" aria-live="polite">
      <p className="consent-banner__text">
        We use Google Analytics cookies to understand how our site is used — only if you agree.{' '}
        <Link className="consent-banner__link" to="/privacy#cookies">Privacy policy</Link>
      </p>
      <div className="consent-banner__actions">
        <Button type="button" variant="outline" onClick={() => decide(false)}>
          Decline
        </Button>
        <Button type="button" variant="outline" onClick={() => decide(true)}>
          Accept
        </Button>
      </div>
    </aside>
  );
};

export default ConsentBanner;
